import { Palmtree, Building2, Briefcase, Mountain, Snowflake, Waves } from "lucide-react";

export type TripType = "beach" | "city" | "business" | "outdoor" | "winter" | "onsen";

export interface TripTypeConfig {
  icon: React.ElementType;
  labelKey: string;
  color: string;
  items: { name: string }[];
}

export const TRIP_TYPE_TEMPLATES: Record<TripType, TripTypeConfig> = {
  beach: {
    icon: Palmtree,
    labelKey: "packing.tripTypes.beach",
    color: "bg-cyan-100 text-cyan-700 border-cyan-200 hover:bg-cyan-200",
    items: [
      { name: "水着" },
      { name: "ビーチサンダル" },
      { name: "帽子" },
      { name: "サングラス" },
      { name: "日焼け止め" },
      { name: "ラッシュガード" },
      { name: "ビーチタオル" },
      { name: "防水ケース" },
      { name: "T-シャツ" },
      { name: "短パン" },
      { name: "下着" },
      { name: "充電器" },
      { name: "財布" },
      { name: "携帯電話" },
    ],
  },
  city: {
    icon: Building2,
    labelKey: "packing.tripTypes.city",
    color: "bg-violet-100 text-violet-700 border-violet-200 hover:bg-violet-200",
    items: [
      { name: "歩きやすい靴" },
      { name: "折りたたみ傘" },
      { name: "モバイルバッテリー" },
      { name: "カメラ" },
      { name: "ガイドブック" },
      { name: "エコバッグ" },
      { name: "T-シャツ" },
      { name: "パンツ" },
      { name: "上着" },
      { name: "下着" },
      { name: "靴下" },
      { name: "充電器" },
      { name: "財布" },
      { name: "携帯電話" },
      { name: "歯ブラシ" },
    ],
  },
  business: {
    icon: Briefcase,
    labelKey: "packing.tripTypes.business",
    color: "bg-slate-100 text-slate-700 border-slate-200 hover:bg-slate-200",
    items: [
      { name: "スーツ" },
      { name: "ワイシャツ" },
      { name: "ネクタイ" },
      { name: "革靴" },
      { name: "名刺" },
      { name: "ノートPC" },
      { name: "PC充電器" },
      { name: "資料" },
      { name: "下着" },
      { name: "靴下" },
      { name: "パジャマ" },
      { name: "充電器" },
      { name: "財布" },
      { name: "携帯電話" },
      { name: "歯ブラシ" },
      { name: "整髪料" },
    ],
  },
  outdoor: {
    icon: Mountain,
    labelKey: "packing.tripTypes.outdoor",
    color: "bg-green-100 text-green-700 border-green-200 hover:bg-green-200",
    items: [
      { name: "トレッキングシューズ" },
      { name: "レインウェア" },
      { name: "リュックサック" },
      { name: "水筒" },
      { name: "ヘッドライト" },
      { name: "虫除けスプレー" },
      { name: "救急セット" },
      { name: "速乾タオル" },
      { name: "日焼け止め" },
      { name: "帽子" },
      { name: "長袖シャツ" },
      { name: "長ズボン" },
      { name: "下着" },
      { name: "靴下" },
      { name: "充電器" },
      { name: "携帯電話" },
    ],
  },
  winter: {
    icon: Snowflake,
    labelKey: "packing.tripTypes.winter",
    color: "bg-sky-100 text-sky-700 border-sky-200 hover:bg-sky-200",
    items: [
      { name: "ダウンジャケット" },
      { name: "ニット帽" },
      { name: "手袋" },
      { name: "マフラー" },
      { name: "ヒートテック" },
      { name: "厚手の靴下" },
      { name: "防水ブーツ" },
      { name: "リップクリーム" },
      { name: "ハンドクリーム" },
      { name: "カイロ" },
      { name: "下着" },
      { name: "パジャマ" },
      { name: "充電器" },
      { name: "財布" },
      { name: "携帯電話" },
    ],
  },
  onsen: {
    icon: Waves,
    labelKey: "packing.tripTypes.onsen",
    color: "bg-orange-100 text-orange-700 border-orange-200 hover:bg-orange-200",
    items: [
      { name: "浴衣用下着" },
      { name: "薄手のタオル" },
      { name: "ヘアゴム" },
      { name: "化粧水" },
      { name: "乳液" },
      { name: "小銭入れ" },
      { name: "ビニール袋" },
      { name: "着替え" },
      { name: "下着" },
      { name: "靴下" },
      { name: "パジャマ" },
      { name: "充電器" },
      { name: "財布" },
      { name: "携帯電話" },
      { name: "歯ブラシ" },
    ],
  },
};
